export enum CourseNotificationCategory {
    GENERAL,
    COMMUNICATION,
}
